import VideoPreview from './VideoPreview';
import './VideoPreview.scss';

export default VideoPreview;
